<template>
  <!-- Global Page Loader -->
  <PageTransitionLoader v-if="isLoading || wsStore.isReload" />

  <!-- Router View with Transition -->
  <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
      <!-- <component :is="Component" /> -->
      <component v-if="!wsStore.isReload" :is="Component" />
    </transition>
  </router-view>
  
</template>

<!-- <template>
  <div id="app">
    <keep-alive>
      <router-view v-slot="{ Component }">
        <transition name="fade">
          <component :is="Component" />
        </transition>
      </router-view>
    </keep-alive>
  </div>
</template> -->

<script setup>
import { RouterLink, RouterView } from 'vue-router'
import { ref, provide, onMounted, computed } from "vue";
const userTheme = ref("light-theme");
import PageTransitionLoader from './components/PageTransitionLoader.vue'
import { useUiStore } from '@/stores'
import { useWebSocketStore } from '@/stores/websocket'
const wsStore = useWebSocketStore()
const uiStore = useUiStore()
const isLoading = computed(() => uiStore.isPageLoading)

provide('userTheme', userTheme);
onMounted(() => {
    if (wsStore.isReload) {
      if (!wsStore.isConnected && !wsStore.socket && !wsStore.logoutTriggered) {
        wsStore.connectWebSocket();
      }
    // 🚫 Freeze app bootstrapping, show loader only
  }
  // Checking theme preference from URL
  const urlParams = new URLSearchParams(window.location.search);
  const preferTheme = urlParams.get("theme");

  // Checking theme preference from localStorage
  const themeAsPerCache = localStorage.getItem("user-theme") || "light-theme";

  // URL theme preference has higher priority
  userTheme.value = preferTheme?.includes("dark")
    ? "dark-theme"
    : preferTheme?.includes("light")
    ? "light-theme"
    : themeAsPerCache;

  // Updating localStorage
  localStorage.setItem("user-theme", userTheme.value);

  // Applying theme to document
  document.documentElement.className = userTheme.value;
});

// Provide theme globally
provide("userTheme", userTheme);
</script>


<style lang="scss">
  @use "./css/index";
  @use "./css/dark-theme";
  @font-face {
  font-family: 'Nunito Sans';
  font-weight: normal;
  src: url("./css/Nunito-Sans-Regular.ttf") format('truetype');
  }
  
  @font-face {
    font-family: 'Nunito Sans';
    font-weight: bold;
    src: url("./css/Nunito-Sans-Bold.ttf") format('truetype');
  }
</style>

